<template lang="html">
  <section class="take-place column">
		<div class="no-estate white-box column" v-if="!investmentStats || Array.isArray(investmentStats)">
			<img src="@/assets/img/folder.svg" alt="">
			<div class="title bold">Mes placements</div>
			<div class="text">
				Bientôt ! Vous pourrez suivre ici vos investissements réalisés avec Patrimoffice.<br>Prenez contact avec votre Patrimofficer
			</div>
			<router-link class="btn btn-red" :to="{ name: 'Advisor' }">
				Contacter mon Patrimofficer
			</router-link>
		</div>
		<div class="take-place from-start column" v-else>
		<common-synthesis :investment-stats="investmentStats" />
		</div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import CommonSynthesis from '@/common/components/Investments/Synthesis.vue'

export default {
	components: {
		CommonSynthesis
	},
	mounted () {
		this.$store.dispatch('getInvestmentStats')
	},
	computed: {
		...mapGetters({
			isEstate: 'isEstate',
			investmentStats: 'investmentStats',
			currentSubscription: 'currentSubscription'
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/views/Investments/Synthesis.vue